import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './styles/main.css'

const app = createApp(App)

app.config.errorHandler = (err, _instance, info) => {
  console.error('[Global Vue Error]', err, info)
}
app.config.warnHandler = (msg, _instance, _trace) => {
  if (msg && typeof msg === 'string' && msg.includes('Failed to resolve component')) return
  console.warn('[Vue Warning]', msg)
}

app.use(createPinia())
app.use(router)

app.mount('#app')
